var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterAdd = function SvgFilterAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.982 7.5c.083-.182.128-.374.16-.627.202-1.572.303-2.358-.157-2.866-.461-.507-1.276-.507-2.907-.507H6.547c-1.63 0-2.446 0-2.907.507-.46.508-.36 1.294-.157 2.866.059.459.157.72.457 1.076.968 1.15 2.742 3.197 5.23 5.057.227.17.377.448.402.755.28 3.425.537 5.765.673 6.917.072.604.742 1.069 1.294.678.927-.655 2.659-1.39 2.888-2.612.108-.577.266-1.585.445-3.244M17.813 8.5v7m3.5-3.5h-7"
  }))));
};
export default SvgFilterAdd;